import FinanceClientDetails from '../Finance/ClientDetails/financeclientdetails';

export default FinanceClientDetails;
